import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type InsightsSummary = {
  summary: string | null;
  generated_at: string | null;
};

// eslint-disable-next-line import/prefer-default-export
export function useInsightsSummary(queryParams: string) {
  return useQuery<InsightsSummary>({
    queryKey: [APIKey.INSIGHTS_SUMMARY, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.insightsSummary()}?${queryParams}`),
    retry: false,
  });
}
